import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("panama",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 12.5L0 4.5L12 4.5L24 12.5L24 20.5H12L0 12.5Z"
                fill="white" />
            <path
                d="M12 4.5L24 4.5V12.5L12 12.5L12 4.5Z"
                fill="#DA121A" />
            <path
                d="M18.0001 14.2441L18.7157 15.967H21.0329L19.1582 17.0322L19.8738 18.7549L18.0001 17.6902L16.1265 18.7549L16.842 17.0322L14.9673 15.967H17.2845L18.0001 14.2441Z"
                fill="#DA121A" />
            <path
                d="M0 12.5L12 12.5L12 20.5H0L0 12.5Z"
                fill="#072357" />
            <path
                d="M6.00011 6.24414L6.71573 7.96695L9.03294 7.96695L7.15821 9.0322L7.87377 10.7549L6.00011 9.69025L4.12646 10.7549L4.84202 9.0322L2.96729 7.96695H5.2845L6.00011 6.24414Z"
                fill="#072357" />
        </svg>
    `),d=t("panama_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_85981)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 12.5L0 0.5L12 0.5L24 12.5V24.5H12L0 12.5Z"
                    fill="white" />
                <path
                    d="M12 0.5L24 0.5V12.5L12 12.5L12 0.5Z"
                    fill="#DA121A" />
                <path
                    d="M16.9986 14.5L17.743 16.7916H20.1534L18.2033 18.2086L18.9476 20.5L16.9986 19.0839L15.0496 20.5L15.7939 18.2086L13.8438 16.7916H16.2542L16.9986 14.5Z"
                    fill="#DA121A" />
                <path
                    d="M0 12.5L12 12.5L12 24.5L0 24.5L0 12.5Z"
                    fill="#072357" />
                <path
                    d="M6.99859 4.5L7.74299 6.79161L10.1534 6.79161L8.20327 8.20856L8.94762 10.5L6.99859 9.08387L5.04956 10.5L5.7939 8.20856L3.84375 6.79161H6.25418L6.99859 4.5Z"
                    fill="#072357" />
            </g>
            <defs>
                <clipPath id="clip0_19470_85981">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Panama,d as PanamaRounded};
